import axios from 'axios';

import {SERVER_URL} from "../../config";
import {appendTimestamp, appendListQuery} from "../../common/shared";

export const getAdminDefaultAllocationOptions = (adminUserId) => {

    console.log("Admin Allocations API - getDefaultAllocationOptions");

    return new Promise((resolve, reject) => {

        let targetUrl = appendTimestamp(`${SERVER_URL}/admin/${adminUserId}/settings/allocation-model/id-name`);

        axios.get(targetUrl)
            .then((response) => {
                let modelList = response.data.payload.map((model) => {
                    return {
                        id: model.allocationModelId,
                        name: model.allocationModelName,
                        isDefault: model.default
                    }
                });

                resolve(modelList);
            });

    });
};

const mapAllocationCategory = (asset) => {
    return {
        id: null,
        assetTypeId: asset.id,
        name: asset.name,
        value: asset.percentage,
        children: asset.assetClassList.map((child) => {
            return {
                assetId: child.id,
                superAssetId: child.superAssetClassId,
                name: child.name,
                value: child.percentage,
                sortOrder: child.sortOrder
            }
        }),
        superAssetClassAlignment: asset.alignment,
        sortOrder: asset.sortOrder,
        assetOrder: asset.assetOrder
    };
};

export const mapFromBEData = (allocation) => {
    return {
        allocationModelId: allocation.allocationModelId,
        allocationModelName: allocation.allocationModelName,
        objectScope: allocation.objectScope,
        assets: allocation.superAssetClassList ? allocation.superAssetClassList.map(mapAllocationCategory) : null,
        returnRate: allocation.grossAverageReturn,
        risk: allocation.standardDeviation,
        annualizedReturn: allocation.annualizedReturn,
        expenseRatio: allocation.customExpenseRatio,
        customValues: allocation.custom,
        customReturnRate: allocation.customGrossAverageReturn,
        customRisk: allocation.customStandardDeviation,
        customAnnualizedReturn: allocation.customAnnualizedReturn,
        createdDate: allocation.createdDate,
        lastUpdateDate: allocation.lastUpdateDate,
        lastUpdatedBy: allocation.lastUpdatedBy,
        defaultForPlan: allocation.defaultForPlan
    };
};

export const getFirmAllocationModels = (adminUserId, listQuery) => {

    console.log("Admin Allocations API - getFirmAllocationModels");

    return new Promise((resolve, reject) => {

        let targetUrl = appendTimestamp(`${SERVER_URL}/admin/${adminUserId}/settings/allocation-model/list`);
        targetUrl = appendListQuery(targetUrl, listQuery);

        axios.get(targetUrl)
            .then((response) => {
                let payload = response.data.payload;

                resolve({
                    allocationModelList: payload.allocationModelList.map(mapFromBEData),
                    totalNumberOfRecords: payload.totalNumberOfRecords
                });
            });
    });
};

export const getFirmAssetClasses = (firmId) => {

    console.log("Admin Allocations API - getFirmAssetClasses");

    return new Promise((resolve, reject) => {

        let targetUrl = appendTimestamp(`${SERVER_URL}/meta/firm/${firmId}/default-assetclasses`);

        axios.get(targetUrl)
            .then((response) => {
                resolve(response.data.payload.map(mapAllocationCategory));
            });
    });
};

const createFirmAllocationModel = (adminUserId, allocationModel) => {
    return new Promise((resolve, reject) => {

        let targetUrl = appendTimestamp(`${SERVER_URL}/admin/${adminUserId}/settings/allocation-model`);

        axios.post(targetUrl, allocationModel)
            .then(() => {
                resolve({});
            });
    });
};

const updateFirmAllocationModel = (adminUserId, allocationModel) => {
    return new Promise((resolve, reject) => {

        let targetUrl = appendTimestamp(`${SERVER_URL}/admin/${adminUserId}/settings/allocation-model/${allocationModel.allocationModelId}`);

        axios.put(targetUrl, allocationModel)
            .then(() => {
                resolve({});
            });
    });
};

export const saveFirmAllocationModel = (adminUserId, allocationModel) => {

    console.log("Admin Allocation API - saveFirmAllocationModel");

    if (allocationModel.allocationModelId === null) {
        return createFirmAllocationModel(adminUserId, allocationModel);
    } else {
        return updateFirmAllocationModel(adminUserId, allocationModel);
    }
};

export const checkIfFirmAllocationIsUsedInPlans = (adminUserId, allocationModelId) => {

    console.log("Admin Allocation API - checkIfAllocationIsUsedInPlans");

    return new Promise((resolve, reject) => {
        let targetUrl = appendTimestamp(`${SERVER_URL}/admin/${adminUserId}/settings/allocation-model/${allocationModelId}/is-used`);

        axios.get(targetUrl)
            .then((response) => {
                resolve(response.data.payload);
            });
    });
};

export const deleteFirmAllocationModal = (adminUserId, allocationModelId, replacementModel) => {

    console.log("Admin Allocation API - deleteAllocationModal");

    return new Promise((resolve, reject) => {
        let targetUrl = appendTimestamp(`${SERVER_URL}/admin/${adminUserId}/settings/allocation-model/${allocationModelId}`);

        axios.post(targetUrl, replacementModel)
            .then((response) => {
                resolve(response.data.payload);
            });
    });
};

export const updateFirmDefaultAllocationModel = (adminUserId, defaultAllocationModel) => {
    console.log("Admin Allocation API - updateDefaultAllocationModel");

    return new Promise((resolve, reject) => {
        let targetUrl = appendTimestamp(`${SERVER_URL}/admin/${adminUserId}/settings/allocation-model/update-default-allocation-model`);

        axios.post(targetUrl, defaultAllocationModel)
            .then((response) => {
                resolve(response.data.payload);
            });
    });
};